import api from './api';

class SettingPromoCodeService {
  getDataPromoCodes(dataForm) {
    return api.post('/merchant/promo-codes', dataForm);
  }

  getDataPromoCodeBundle(dataForm) {
    return api.post('/merchant/promo-codes-bundle', dataForm);
  }

  deletePromoCode(promoCodeId) {
    return api.post('/merchant/promo-code/delete/' + promoCodeId);
  }

  changeStatus(promoCodeId) {
    return api.post('/merchant/promo-code/change-status/' + promoCodeId);
  }

  changeStatusPromoCodeBundle(promoCodeId) {
    return api.post('/merchant/promo-code-bundle/change-status/' + promoCodeId);
  }

  createNewPromoCode() {
    return api.post('/merchant/promo-code');
  }

  createNewPromoCodeBundle() {
    return api.post('/merchant/promo-code-bundle');
  }

  getDataPromoCodeDetail(promoCodeId) {
    return api.post('/merchant/promo-code/' + promoCodeId);
  }

  getDataPromoCodeDistribution(promoCodeId, page = 1, filters = {}) {
    return api.post('/merchant/promo-code/' + promoCodeId + '/list-distributions', { ...filters, page: page });
  }

  getDataPromoCodeBundleDetail(promoCodeId) {
    return api.post('/merchant/promo-code-bundle/' + promoCodeId);
  }

  addOrUpdatePromoCode(dataForm) {
    return api.post('/merchant/promo-codes/create-or-update', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  addOrUpdatePromoCodeBundle(dataForm) {
    return api.post('/merchant/promo-code-bundle/create-or-update', dataForm, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  changeQuantity(dataForm) {
    return api.post('/merchant/promo-code-change-quantity', dataForm);
  }

  voucherExchanged(dataForm) {
    return api.post('/merchant/promo-code-exchanged', dataForm);
  }

  getFilterData(dataForm) {
    return api.post('/merchant/promo-code-get-filter-data', dataForm);
  }

  applyForItems(dataForm) {
    return api.post('/merchant/promo-code-apply-for-items', dataForm);
  }

  // Only writer of the promo's schedules and their switch; [] clears the schedules.
  saveSchedules(promoCodeId, schedules, enabled) {
    return api.post('/merchant/promo-codes/save-schedules', {
      promo_code_id: promoCodeId,
      schedules_enabled: enabled,
      schedules: schedules,
    });
  }
}

export default new SettingPromoCodeService();
